import { FeatureFlag } from '../FeatureFlag';

export const enableMosaicGridTemplates = new FeatureFlag({
    key: 'enable-mosaic-grid-templates',
    defaultValue: false,
});
